import { Badge, List, Space, Tag } from "antd";
import React from "react";
import _ from "lodash";

class Commitments extends React.Component {
  renderSessionList = () => {
    let sessions = this.props.data.sessions;
    if (!sessions || sessions.length === 0) {
      return null;
    }
    return (
      <List
        size="small"
        bordered={true}
        itemLayout="vertical"
        dataSource={sessions}
        renderItem={(item, index) => {
          let session = item;
          let people = session.people;
          let currentPerson = _.filter(
            people,
            (x) => x.delegateId === this.props.data.delegateInfo._id
          );
          let role = "";
          if (!currentPerson || currentPerson.length === 0) {
            role = "Participant";
          } else {
            role = currentPerson.map((x) => x.role).join(", ");
          }
          return (
            <List.Item
              key={index}
              onClick={() => this.props.onSelectSessionId(item._id)}
            >
              <List.Item.Meta
                title={
                  item.hasConflict ? (
                    <Badge
                      count={item.nConflict}
                      offset={[12, -1]}
                      size="small"
                    >
                      {item.title}
                    </Badge>
                  ) : (
                    <> {item.title}</>
                  )
                }
                description={role}
              />
              <Space.Compact>
                <Tag>{_.startCase(_.lowerCase(item.onDay))}</Tag>{" "}
                <Tag>{_.startCase(_.lowerCase(item.resourceId))}</Tag>{" "}
                <Tag>{_.startCase(_.lowerCase(item.sessionType))}</Tag>
              </Space.Compact>
            </List.Item>
          );
        }}
      />
    );
  };
  render() {
    return <div>{this.renderSessionList()}</div>;
  }
}

export default Commitments;
